import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'enhanced-radio',
  templateUrl: './enhanced-radio.component.html',
  styleUrls: ['./enhanced-radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnhancedRadioComponent {
  @Input() identifier: string;
  @Input() label: string;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;

  @Input() selected: boolean;
  @Output() changed = new EventEmitter<boolean>();

  @ViewChild('radioElement', { static: false })
  radioElement: ElementRef<HTMLInputElement>;

  focus() {
    this.radioElement.nativeElement.focus();
  }
}
